/**
 * @name webcam-off
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjJ2LTQiIC8+CiAgPHBhdGggZD0iTTEyLjc1NCA3LjA5NmEzIDMgMCAwIDEgMi4xNSAyLjE1IiAvPgogIDxwYXRoIGQ9Ik0xMi44NjMgMTIuODczYTMgMyAwIDAgMS0zLjczNi0zLjczNSIgLz4KICA8cGF0aCBkPSJNMTYuNTY2IDE2LjU3QTggOCAwIDAgMSA1LjQzIDUuNDMzIiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTcgMjJoMTAiIC8+CiAgPHBhdGggZD0iTTguNDc4IDIuODE3YTggOCAwIDAgMSAxMC43MDUgMTAuNzA1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/webcam-off
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const WebcamOff: string = `
<svg
  class="lucide lucide-webcam-off"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 22v-4" />
  <path d="M12.754 7.096a3 3 0 0 1 2.15 2.15" />
  <path d="M12.863 12.873a3 3 0 0 1-3.736-3.735" />
  <path d="M16.566 16.57A8 8 0 0 1 5.43 5.433" />
  <path d="m2 2 20 20" />
  <path d="M7 22h10" />
  <path d="M8.478 2.817a8 8 0 0 1 10.705 10.705" />
</svg>
`;

export default WebcamOff;
